import { useAuth } from '../../context/AuthContext.jsx';

export default function Header() {
  const { user } = useAuth();

  const initial = (user?.name || user?.email || '?')[0].toUpperCase();

  return (
    <header className="flex h-14 items-center justify-between border-b border-gray-200 bg-white px-6">
      <div className="text-sm font-medium text-gray-500">Admin Console</div>
      <div className="flex items-center gap-3">
        <span className="rounded-full bg-blue-100 px-2 py-0.5 text-xs font-medium text-blue-700">VISTA Admin</span>
        <div className="flex h-8 w-8 items-center justify-center rounded-full bg-blue-600 text-sm font-medium text-white">
          {initial}
        </div>
        <span className="text-sm text-gray-700">{user?.name || user?.email}</span>
        <button
          onClick={() => { window.location.href = '/cdn-cgi/access/logout'; }}
          className="text-xs text-gray-400 hover:text-gray-600"
        >
          Sign out
        </button>
      </div>
    </header>
  );
}
